import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import {
  selectFollowedStoreIds,
  selectIsStoreFollowed,
  toggleFollowStore
} from "../../routes/Store/store.ducks";
import { selectUserInfo } from "../../routes/Auth/auth.ducks";
import { rootReducerInterface } from "../../typings/interfaces";
import styles from "./followStoreButton.scss";

interface Props {
  storeId?: string;
  className?: string;
  gaCategory?: string;
  gaLabel?: string;
}

const FollowStoreButton = ({ storeId, className, gaCategory, gaLabel }: Props) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUserInfo);
  const followedIds = useSelector(selectFollowedStoreIds);
  const isFollowed = useSelector((state: rootReducerInterface) =>
    selectIsStoreFollowed(state, storeId)
  );
  const [isLoading, setIsLoading] = useState(false);

  if (!storeId) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (isLoading) return;

    const action = isFollowed ? "Otprati" : "Prati";
    ReactGA.event({
      category: gaCategory || "Praćenje oglašivača",
      action: "Click",
      label: gaLabel ? `Klik na ${action} - ${gaLabel}` : action
    });

    setIsLoading(true);
    Promise.resolve(
      // @ts-ignore - thunk dispatch signature
      dispatch(toggleFollowStore(storeId, followedIds, user))
    )
      .finally(() => setIsLoading(false));
  };

  const buttonClass = `${styles.button} ${isFollowed ? styles.buttonActive : ""} ${className || ""}`;

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={handleClick}
      disabled={isLoading}
    >
      {isFollowed ? "Otprati oglašivača" : "Prati oglašivača"}
    </button>
  );
};

export default FollowStoreButton;



// WEBPACK FOOTER //
// ./src/components/FollowStoreButton/FollowStoreButton.tsx